<template>
  <div>{{ categorie }}</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: {object: {type: Object, required: true}},
    data(){
        return {

        }
    },
    computed: {
        ...mapGetters({
            categories: 'sanitaire/categorieAnalyses'
        }),
        categorie(){
            let t = this.categories.find(item => item.uid === this.object.categorieAnalyse)
            if(t) return t.libelle
            return '-'
        }
    }
}
</script>

<style>

</style>